var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3645 9.22241L16.9255 16.8912",
    stroke: "#154365",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28515 5.9275C4.73415 6.37651 5.46213 6.37651 5.91114 5.9275C6.36014 5.4785 6.36014 4.75052 5.91114 4.30152C5.46213 3.85251 4.73416 3.85251 4.28515 4.30152C3.83615 4.75052 3.83615 5.4785 4.28515 5.9275Z",
    stroke: "#154365",
    strokeWidth: 1.42857,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4405 14.7217L10.4958 7.77688C11.1792 6.17827 10.58 4.39668 9.27505 3.0917C7.56751 1.38416 4.79919 1.38416 3.09165 3.0917C1.3841 4.79924 1.3841 7.56757 3.09165 9.27511C4.38128 10.5647 5.74693 11.1285 7.33389 10.4764L9.77259 12.9151L10.0773 12.6104L10.948 13.4375L10.6215 13.764L11.3833 14.5259L11.7533 14.1559L12.5368 15.0266L12.2321 15.3748L12.994 16.1367L13.2333 15.8538L14.0822 16.6591L13.8211 16.9638L14.7183 17.4442L16.9256 16.8912L17.4405 14.7217Z",
    stroke: "#154365",
    strokeWidth: 1.42857,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.d73391b35305b7b75c993738c735be38.svg";
export { ForwardRef as ReactComponent };